import { LoyaltyHomepageFooter, useIsLoyaltyHomepageEnabled } from '@fhs/loyalty-homepage';

import { Footer as LegacyFooter } from './footer';

export default function Footer() {
  const isLoyaltyHomepageEnabled = useIsLoyaltyHomepageEnabled();

  if (isLoyaltyHomepageEnabled) {
    return <LoyaltyHomepageFooter />;
  }

  return <LegacyFooter />;
}
